import moment from 'moment';
import { TableInput, TextAreaInput } from '../../../../../components/common';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import { useQuery } from '../../../../../hooks/UseQuery';
import React from 'react';

interface Ifoot {
  preparedBy: string | null | undefined;
  approvedBy: string | null | undefined;
}
const TFoot = ({ moduleData, updateModuleData }: any) => {
  const isView = useQuery('isView') === 'true' ? true : false;
  const handleInputChange = (
    fieldName: string,
    value: string | number | null,
  ) => {
    updateModuleData('key-pair', null, fieldName, { [fieldName]: value });
  };

  return (
    <tfoot>
     <tr>
             <th colSpan={5} align="left">
             PREPARED BY :{' '}
               <TableInput
                 isView={isView}
                 name="prepared_by"
                 value={moduleData?.prepared_by}
                 onChange={(e: any) => handleInputChange(e.target.name, e.target.value)} type={''}          />
             </th>
             <th colSpan={4} align="left">
             APPROVED BY :{' '}
               <TableInput
                 isView={isView}
                 name="approved_by"
                 value={moduleData?.approved_by}
                 onChange={(e: any) => handleInputChange(e.target.name, e.target.value)} type={''}          />
             </th>
           </tr>
    </tfoot>
  );
};

export default React.memo(TFoot);
